import { curry, isNil, pipe } from 'ramda'

export const enumKeys = _enum => Object.keys(_enum).filter(x => !(parseInt(x) >= 0))

export const valueToEnum = curry((_enum, enumValue: string | number) => {
  const keys = Object.keys(_enum).filter(x => _enum[x] == enumValue)
  return keys.length > 0 ? keys[0] : enumValue
})

export const enumToText = curry((defEnum, key) => {
  if (isNil(defEnum[key])) return key
  return defEnum[key]
})

export const enumValueToText = (_enum, defEnum): (<T = any, K = any>(v: T) => K) =>
  pipe(valueToEnum(_enum) as any, enumToText(defEnum) as any)
